module.exports = __webpack_public_path__ + "static/media/fashionnet.13428162.png";